import React from 'react';

import ExpandableSection from './ExpandableSection';
import css from './ListingPage.module.css';

const KNOWN_HEADINGS = [
  'Description générale',
  'General description',
  'Spécifications techniques',
  'Technical specifications',
  'Compatibilité et accessoires',
  'Compatibility and accessories',
  'Installation',
  'Utilisation',
  'Usage',
  'Caractéristiques',
  'Caractéristiques techniques',
  'Features',
  'Composition',
  'Dimensions',
];

function parseDescriptionSections(text) {
  if (!text) return null;

  // Only match headings that are:
  // - At the start of the text, OR
  // - After a newline, OR  
  // - After a colon followed by optional whitespace and newline
  // This prevents matching "Dimensions" in "• Dimensions du mortier"
  const headingsPattern = KNOWN_HEADINGS.map(h => h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  const pattern = new RegExp(
    `(^|\\n|:\\s*\\n?)\\s*(${headingsPattern})\\s*[:.]?\\s*(?=\\n|$|[A-Z])`,
    'gm'
  );

  // Check if we have any real section headings (not just inline mentions)
  const matches = text.match(pattern);
  if (!matches || matches.length === 0) return null;

  // For simple descriptions without clear sections, just return plain text
  // Only parse sections if headings appear to be standalone (followed by newline or end)
  const hasStandaloneHeadings = matches.some(m => {
    const trimmed = m.trim();
    return KNOWN_HEADINGS.some(h => trimmed === h || trimmed.endsWith(h) || trimmed.endsWith(h + ':'));
  });

  if (!hasStandaloneHeadings) return null;

  // Split and parse sections
  const splitPattern = new RegExp(
    `(?:^|\\n)\\s*(${headingsPattern})\\s*[:.]?\\s*`,
    'gm'
  );

  const parts = text.split(splitPattern).filter(p => p && p.trim());
  if (parts.length <= 1) return null;

  const sections = [];
  let i = 0;
  if (!KNOWN_HEADINGS.includes(parts[0]?.trim())) {
    sections.push({ heading: null, body: parts[0].trim() });
    i = 1;
  }
  while (i < parts.length) {
    const heading = parts[i]?.trim();
    const body = parts[i + 1]?.trim() || '';
    if (KNOWN_HEADINGS.includes(heading)) {
      sections.push({ heading, body });
      i += 2;
    } else {
      i += 1;
    }
  }
  return sections.length > 0 ? sections : null;
}

const SectionDescriptionMaybe = props => {
  const { description, intl } = props;
  if (!description) return null;

  const sections = parseDescriptionSections(description);

  return (
    <ExpandableSection
      className={css.sectionMargins}
      title={intl.formatMessage({ id: 'ListingPage.descriptionTitle' })}
    >
      {sections ? (
        <div className={css.descriptionSections}>
          {sections.map((section, idx) => (
            <div key={idx} className={css.descriptionSection}>
              {section.heading ? (
                <p className={css.descriptionSectionHeading}>{section.heading}</p>
              ) : null}
              {section.body ? (
                <p className={css.descriptionSectionBody}>{section.body}</p>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <p className={css.descriptionPlain}>{description}</p>
      )}
    </ExpandableSection>
  );
};

export default SectionDescriptionMaybe;
